/**
 * Допуск в пикселях при сравнении содержимого с размером элемента.
 *
 * Размеры элемента браузер отдаёт целыми числами: доступную ширину округляет вниз, ширину
 * содержимого — вверх. На дробной раскладке (проценты, `flex`) это даёт лишний пиксель у текста,
 * который помещается целиком, — без допуска подсказка появлялась бы у неусечённого текста.
 */
const SIZE_TOLERANCE = 1;

/**
 * Содержимое не помещается в элемент и усечено — по ширине (одна строка) или по высоте
 * (несколько строк).
 *
 * Проверяется в момент показа подсказки, а не при отрисовке: так ответ всегда соответствует
 * текущей ширине элемента, каким бы образом она ни менялась — окном, панелью, колонкой таблицы.
 */
export const isElementTruncated = (element: HTMLElement): boolean =>
  element.scrollWidth > element.clientWidth + SIZE_TOLERANCE ||
  element.scrollHeight > element.clientHeight + SIZE_TOLERANCE;
